import React, { useState } from 'react';
import { Modal } from '../Modal';
import { Text } from '../Text';

interface CancelMeetingModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
  isLoading?: boolean;
  isRequest?: boolean;
}

export const CancelMeetingModal: React.FC<CancelMeetingModalProps> = ({ open, onClose, onConfirm, isLoading, isRequest }) => {
  const [reason, setReason] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (reason.trim()) {
      onConfirm(reason.trim());
    }
  };

  return (
    <Modal open={open} onClose={onClose} className="max-w-md rounded-2xl">
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <div className="flex flex-col gap-1">
          <Text variant="title" className="!font-FigtreeBold">{isRequest ? "Request Cancellation" : "Cancel Meeting"}</Text>
          <Text variant="body" className="text-ui_placeholder">{isRequest ? "Are you sure you want to request cancellation for this meeting? Please provide a reason." : "Are you sure you want to cancel this meeting? Please provide a reason."}</Text>
        </div>
        
        <textarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Reason for cancellation..."
          className="w-full p-3 border border-gray-200 rounded-lg outline-none focus:border-ui_blue min-h-[100px] resize-none"
          required
        />
        
        <div className="flex justify-end gap-3 mt-2">
          <button
            type="button"
            onClick={onClose}
            disabled={isLoading}
            className="px-4 py-2 rounded-lg font-FigtreeMeduim border border-gray-200 text-gray-600 hover:bg-gray-50 transition-colors"
          >
            Go Back
          </button>
          <button
            type="submit"
            disabled={isLoading || !reason.trim()}
            className="px-4 py-2 rounded-lg font-FigtreeMeduim bg-red-500 text-white hover:bg-red-600 transition-colors disabled:opacity-50"
          >
            {isLoading ? (isRequest ? 'Requesting...' : 'Cancelling...') : (isRequest ? 'Request Cancellation' : 'Cancel Meeting')}
          </button>
        </div>
      </form>
    </Modal>
  );
};
